<template>
	<div class="flex-grow flex flex-col py-5 px-8">
		<Header :title="$t('vehicle').toString()">
			<p>
				{{ hasExistingVehicle ? 'Fahrzeugdaten bearbeiten.' : 'Fahrzeugdaten hinzufügen.' }}
			</p>
		</Header>
		<div v-if="!isLoading" class="main">
			<CustomerVehicleForm ref="VehicleForm" v-model="vehicle" :display="true" validation-mode="damageAssessorCase" @updateValue="vehicle = $event" />
		</div>
		<LoadingSpinner v-else />
		<Footer v-if="!isLoading" @backButtonClick="goBack" :is-back-button="true" :is-continue-button="false" :is-skippable="false" class="m-8">
			<template #right>
				<BaseButton @click="save" :disabled="isSaving" class="btn-blue">
					{{ $t('general.save') }}
				</BaseButton>
			</template>
		</Footer>
	</div>
</template>

<script>
import Header from '@/components/damagecases/Header';

import Footer from '@/components/damagecases/Footer';

import CustomerVehicleForm from '@/components/forms/CustomerVehicleForm';

import BaseButton from '@/components/forms/buttons/BaseButton';

import LoadingSpinner from '@/components/navigation/LoadingSpinner';

import DamageAssessorCaseRepository from '@/api/repositories/DamageAssessorCaseRepository';

import Authentication from '@/mixins/Authentication';

export default {
	name: 'DamageAssessorCaseEditVehicle',
	mixins: [Authentication],
	components: {
		Header,
		Footer,
		CustomerVehicleForm,
		BaseButton,
		LoadingSpinner,
	},
	data() {
		return {
			isLoading: true,
			isSaving: false,
			damageAssessorCase: null,
			vehicle: null,
			hasExistingVehicle: false,
		};
	},
	mounted() {
		this.$store.commit('setConfirmLeaving', this.$t('leave_page'));
		this.load();
	},
	destroyed() {
		this.$store.commit('setConfirmLeaving', false);
	},
	methods: {
		load() {
			this.isLoading = true;
			new DamageAssessorCaseRepository()
				.getDamageAssessorCaseDetail(this.$route.params.id)
				.then(response => {
					this.damageAssessorCase = response.data;
					this.hasExistingVehicle = !!this.damageAssessorCase.vehicle;
					this.vehicle = this.hasExistingVehicle ? JSON.parse(JSON.stringify(this.damageAssessorCase.vehicle)) : this.createEmptyVehicle();
				})
				.catch(error => {
					console.log(error);
					this.showError();
				})
				.finally(() => {
					this.isLoading = false;
				});
		},
		createEmptyVehicle() {
			return {
				manufacturer: null,
				model: null,
				vehicleIdentificationNumber: null,

				licensePlate: {
					isSpecial: false,
					text: null,
				},

				isAuthorizedForInputTaxDeduction: null,
				rentalCarClass: null,

				registrationFirst: null,
				registrationFirstRaw: null,

				registrationLast: null,
				registrationLastRaw: null,

				au: null,
				hu: null,
				fuel: null,
				exhaustKey: null,
				kmMiKey: null,
				kw: null,
				ps: null,
				displacement: null,
				note: null,

				yearOfConstruction: null,
				numberOfPreviousOwners: null,
				kilometrage: null,
				kilometrageChanges: [],
			};
		},
		buildVehicleDto() {
			const vehicle = {
				...this.vehicle,
			};
			vehicle.registrationFirst = this.getVehicleDateForPayload(this.vehicle.registrationFirst, this.vehicle.registrationFirstRaw);
			vehicle.registrationLast = this.getVehicleDateForPayload(this.vehicle.registrationLast, this.vehicle.registrationLastRaw);

			delete vehicle.registrationFirstRaw;
			delete vehicle.registrationLastRaw;
			return vehicle;
		},
		save() {
			if (this.isSaving || !this.vehicle || !this.$refs.VehicleForm) {
				return;
			}
			if (!this.$refs.VehicleForm.validate()) {
				this.showValidationError();
				return;
			}
			this.isSaving = true;
			const payload = {
				vehicle: this.buildVehicleDto(),
			};
			new DamageAssessorCaseRepository()
				.updateDamageAssessorCase(this.damageAssessorCase.id, payload)
				.then(() => {
					this.$store.commit('setConfirmLeaving', false);
					return this.$swal({
						title: this.$t('general.success').toString(),
						text: this.$t('general.changes_saved').toString(),
						icon: 'success',
					});
				})
				.then(() => {
					this.goBack();
				})
				.catch(error => {
					console.log(error);
					this.showError();
				})
				.finally(() => {
					this.isSaving = false;
				});
		},
		getVehicleDateForPayload(value, rawValue) {
			const isoDateRegex = /^\d{4}-\d{2}-\d{2}$/;
			if (isoDateRegex.test(rawValue ?? '')) {
				return rawValue;
			}
			if (isoDateRegex.test(value ?? '')) {
				return value;
			}
			return null;
		},
		goBack() {
			this.$store.commit('setConfirmLeaving', false);
			this.$router.push({
				name: 'damageAssessorCaseDetail',
				params: {
					id: this.$route.params.id,
				},
			});
		},
		showValidationError() {
			this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
		},
		showError() {
			this.$swal(this.$t('general.error').toString(), this.$t('general.changes_not_saved').toString(), 'error');
		},
	},
};
</script>

<style scoped></style>
